export default "__VITE_PUBLIC_ASSET__a5198667__"